'use client';

import { useEffect } from 'react';
import { useParams, useRouter, useSearchParams } from 'next/navigation';
import {
  buildSocietySearchHref,
  type SearchType,
} from '@/lib/publicSearchPaths';
import { SEARCH_PARAM } from '@/constants/searchParams';
import { SEARCH_TYPE } from '@/constants/searchType';

/** Legacy `/{org}/search` and `?searchType=…` → canonical path (e.g. `/{org}/animals`). */
export default function SocietySearchLegacyRedirect() {
  const router = useRouter();
  const params = useParams<{ orgName: string }>();
  const searchParams = useSearchParams();

  useEffect(() => {
    const org = params.orgName;
    if (!org) return;

    const st = searchParams.get(SEARCH_PARAM.SEARCH_TYPE) as SearchType | null;
    const targetType: SearchType = st ?? SEARCH_TYPE.ANIMAL;
    const href = buildSocietySearchHref(org, targetType, searchParams);

    if (
      typeof window !== 'undefined' &&
      `${window.location.pathname}${window.location.search}` !== href
    ) {
      router.replace(href);
    }
  }, [router, params.orgName, searchParams]);

  return null;
}
